export default {
	data: () => ({
		msg: {
			ok: '',
			err: '',
		}
	}),
	methods: {
		errHandlerBefore(){},
		errHandlerAfter(){},
		okHandlerBefore(){},
		okHandlerAfter(){},

		async okHandler(){
			await this.okHandlerBefore();
			await this.error
				? this.errHandler(this.error)
				: this.$refs.Alerts.showAlert(this.msg.ok, 'success');
			await this.okHandlerAfter();
		},
		async errHandler(error){
			await this.errHandlerBefore();
			await this.$refs.Alerts.showAlert(error.non_field_errors ? error.non_field_errors[0] : this.msg.err, 'error')
			await this.errHandlerAfter();
		},
	}
};
